import produce from 'immer';

// TYPES
import { Types, CadastrarPerfil } from './types';
import { ReducerActionRotaSP } from '../../../../../types';

export const INITIAL_STATE: CadastrarPerfil = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): CadastrarPerfil {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRAR_PERFIL: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CADASTRAR_PERFIL_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CADASTRAR_PERFIL_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CADASTRAR_PERFIL_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
